// ---------- Generic carousel (related products / reviews) ----------
function initCarousel(root) {
  if (!root || root.dataset.carouselInit === 'true') return;
  root.dataset.carouselInit = 'true';

  var track = root.querySelector('[data-ctrack]');
  var prevBtn = root.querySelector('[data-cprev]');
  var nextBtn = root.querySelector('[data-cnext]');
  var dotsWrap = root.querySelector('[data-cdots]');
  if (!track || !track.children.length) return;

  var cards = track.children;

  function cardStep() {
    var first = cards[0];
    if (!first) return 300;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.gap || style.columnGap || 0) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });
  }

  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    for (var i = 0; i < cards.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'carousel-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', (function (idx) {
        return function () {
          cards[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        };
      })(i));
      dotsWrap.appendChild(dot);
    }
    var dots = dotsWrap.children;
    var updateDots = function () {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var closestDist = Infinity;
      for (var j = 0; j < cards.length; j++) {
        var dist = Math.abs(cards[j].offsetLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = j;
        }
      }
      for (var k = 0; k < dots.length; k++) {
        dots[k].classList.toggle('is-active', k === closest);
      }
    };
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateDots);
    }, { passive: true });
    updateDots();
  }

  var autoplay = root.dataset.autoplay === 'true';
  var speed = parseInt(root.dataset.autoplaySpeed || '4500', 10);
  if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var timer = null;
    var stop = function () {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    var start = function () {
      stop();
      timer = setInterval(function () {
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        }
      }, speed);
    };
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('focusin', stop);
    start();
  }
}

// ---------- Native Shopify product recommendations ----------
function initRecommendations() {
  document.querySelectorAll('[data-recommendations]').forEach(function (section) {
    var url = section.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newTrack = doc.querySelector('[data-ctrack].related-products-track');
        var oldTrack = section.querySelector('[data-ctrack].related-products-track');
        if (newTrack && oldTrack && newTrack.children.length) {
          oldTrack.innerHTML = newTrack.innerHTML;
          initCarousel(section);
        } else {
          section.style.display = 'none';
        }
      })
      .catch(function () {
        section.style.display = 'none';
      });
  });
}

// ---------- Accordions ----------
function initAccordions() {
  document.querySelectorAll('[data-accordion-list]').forEach(function (list) {
    var allowMultiple = list.dataset.allowMultiple === 'true';
    var triggers = list.querySelectorAll('.accordion-trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (!allowMultiple) {
          triggers.forEach(function (other) {
            if (other !== trigger) {
              other.setAttribute('aria-expanded', 'false');
              var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
              if (otherPanel) {
                otherPanel.classList.remove('is-open');
                otherPanel.setAttribute('aria-hidden', 'true');
              }
            }
          });
        }

        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) {
          panel.classList.toggle('is-open', !isOpen);
          panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        }
      });
    });
  });
}

// ---------- Product variant selection, price, availability, dynamic checkout ----------
function initProductForm() {
  var form = document.getElementById('ProductForm');
  if (!form) return;

  var jsonEl = document.querySelector('script[id^="ProductVariantsJson-"]');
  if (!jsonEl) return;

  var variants;
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  var optionSelects = form.querySelectorAll('.product-option-select');
  var variantIdInput = document.getElementById('ProductVariantId');
  var priceEl = document.getElementById('ProductPrice');
  var comparePriceEl = document.getElementById('ProductComparePrice');
  var availabilityEl = document.getElementById('ProductAvailability');
  var submitBtn = document.getElementById('ProductSubmitButton');
  var submitLabel = document.getElementById('ProductSubmitLabel');

  function getSelectedOptions() {
    var opts = [];
    optionSelects.forEach(function (select) {
      opts.push(select.value);
    });
    return opts;
  }

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function updateUI(variant) {
    if (!variant) return;

    if (variantIdInput) {
      variantIdInput.value = variant.id;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (priceEl) {
      priceEl.textContent = variant.price;
      if (typeof variant.price_ils === 'number') {
        priceEl.setAttribute('data-price-ils', variant.price_ils);
        if (window.refreshPriceEstimate) window.refreshPriceEstimate(variant.price_ils);
      }
    }
    if (comparePriceEl) {
      if (variant.compare_at_price) {
        comparePriceEl.textContent = variant.compare_at_price;
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.hidden = true;
      }
    }

    var availabilityText = '';
    var available = variant.available;
    if (!available) {
      availabilityText = 'Sold out';
    } else if (variant.inventory_management && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue') {
      availabilityText = 'Available on backorder';
    }
    if (availabilityEl) availabilityEl.textContent = availabilityText;

    if (submitBtn) submitBtn.disabled = !available;
    if (submitLabel) submitLabel.textContent = available ? 'Add to Bag' : 'Sold Out';
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      var variant = findVariant(getSelectedOptions());
      updateUI(variant);
    });
  });
}

// ---------- Quantity stepper ----------
function initQuantityStepper() {
  document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input[type="number"]');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        input.value = Math.max(min, val - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }
  });
}

// ---------- Review "Read more" truncation ----------
function initReviewReadMore() {
  document.querySelectorAll('.review-text[data-review-text]').forEach(function (textEl) {
    var toggle = textEl.parentElement.querySelector('[data-readmore-toggle]');
    if (!toggle) return;
    // Allow layout to settle before measuring
    window.requestAnimationFrame(function () {
      if (textEl.scrollHeight > textEl.clientHeight + 2) {
        toggle.hidden = false;
        toggle.addEventListener('click', function () {
          var expanded = textEl.classList.toggle('is-expanded');
          toggle.textContent = expanded ? 'Read less' : 'Read more';
        });
      }
    });
  });
}

// ---------- Add to Bag via AJAX (stays on page, animates button) ----------
function initAjaxAddToCart() {
  var form = document.getElementById('ProductForm');
  if (!form) return;

  var submitBtn = document.getElementById('ProductSubmitButton');
  var submitLabel = document.getElementById('ProductSubmitLabel');
  var errorEl = document.getElementById('CartAddError');
  var cartCountEl = document.querySelector('.cart-count');

  if (!submitBtn || !submitLabel) return;

  var defaultLabel = submitLabel.textContent.trim();
  var resetTimer = null;

  function setError(message) {
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cartCountEl) cartCountEl.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitBtn.disabled) return;

    setError(null);
    submitBtn.disabled = true;
    submitLabel.textContent = 'Adding...';

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.data && result.data.description) || 'This item could not be added to your bag.';
          setError(message);
          submitBtn.disabled = false;
          submitLabel.textContent = defaultLabel;
          return;
        }

        updateCartCount();

        submitBtn.classList.add('is-added');
        submitLabel.innerHTML =
          '<svg class="btn-check" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M2 7l3.5 3.5L12 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>Added to Bag';

        if (resetTimer) clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          submitBtn.classList.remove('is-added');
          submitLabel.textContent = defaultLabel;
          submitBtn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        setError('Something went wrong. Please try again.');
        submitBtn.disabled = false;
        submitLabel.textContent = defaultLabel;
      });
  });
}

// ---------- Estimated local-currency price (display only, geolocation-based) ----------
function initPriceEstimate() {
  var priceEl = document.getElementById('ProductPrice');
  var estimateEl = document.getElementById('PriceEstimate');
  if (!priceEl || !estimateEl) return;

  var COUNTRY_CURRENCY = {
    US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD', JP: 'JPY',
    DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR',
    AT: 'EUR', PT: 'EUR', IE: 'EUR', FI: 'EUR', GR: 'EUR', LU: 'EUR',
    SK: 'EUR', SI: 'EUR', EE: 'EUR', LV: 'EUR', LT: 'EUR', CY: 'EUR', MT: 'EUR', HR: 'EUR'
  };

  var currentRate = null;
  var currentCurrency = null;

  function renderEstimate(priceIls) {
    if (!currentRate || !currentCurrency || !priceIls) {
      estimateEl.hidden = true;
      return;
    }
    var converted = priceIls * currentRate;
    var maxDigits = currentCurrency === 'JPY' ? 0 : 2;
    var formatted;
    try {
      formatted = new Intl.NumberFormat(navigator.language || 'en-US', {
        style: 'currency',
        currency: currentCurrency,
        maximumFractionDigits: maxDigits
      }).format(converted);
    } catch (e) {
      estimateEl.hidden = true;
      return;
    }
    estimateEl.textContent = '\u2248 ' + formatted + ' estimated \u2014 you will be charged in ILS (\u20AA)';
    estimateEl.hidden = false;
  }

  window.refreshPriceEstimate = function (priceIls) {
    renderEstimate(priceIls);
  };

  // ---- Exchange rate: try open.er-api.com, fall back to exchangerate.host ----
  function fetchRate(currency) {
    return fetch('https://open.er-api.com/v6/latest/ILS')
      .then(function (res) {
        if (!res.ok) throw new Error('primary rate provider failed');
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.rates || !data.rates[currency]) throw new Error('currency missing');
        return data.rates[currency];
      })
      .catch(function () {
        return fetch('https://api.exchangerate.host/latest?base=ILS&symbols=' + currency)
          .then(function (res) {
            if (!res.ok) throw new Error('fallback rate provider failed');
            return res.json();
          })
          .then(function (data) {
            if (!data || !data.rates || !data.rates[currency]) throw new Error('currency missing (fallback)');
            return data.rates[currency];
          });
      });
  }

  function loadRateAndRender(currency) {
    var cacheKey = 'wtp_rate_' + currency;
    var cached = null;
    try {
      cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
    } catch (e) {}

    if (cached && cached.rate && (Date.now() - cached.time) < 1000 * 60 * 60) {
      currentRate = cached.rate;
      currentCurrency = currency;
      renderEstimate(parseFloat(priceEl.dataset.priceIls));
      return;
    }

    fetchRate(currency)
      .then(function (rate) {
        currentRate = rate;
        currentCurrency = currency;
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ rate: rate, time: Date.now() }));
        } catch (e) {}
        renderEstimate(parseFloat(priceEl.dataset.priceIls));
      })
      .catch(function (err) {
        if (window.console) console.warn('[price-estimate] exchange rate lookup failed:', err);
      });
  }

  // ---- Country detection: try ipapi.co, fall back to ipwho.is ----
  function fetchCountry() {
    return fetch('https://ipapi.co/json/')
      .then(function (res) {
        if (!res.ok) throw new Error('primary geo provider failed');
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.country_code) throw new Error('no country_code');
        return data.country_code;
      })
      .catch(function () {
        return fetch('https://ipwho.is/')
          .then(function (res) {
            if (!res.ok) throw new Error('fallback geo provider failed');
            return res.json();
          })
          .then(function (data) {
            if (!data || data.success === false || !data.country_code) throw new Error('no country_code (fallback)');
            return data.country_code;
          });
      });
  }

  var cachedCountry = null;
  try {
    cachedCountry = sessionStorage.getItem('wtp_country');
  } catch (e) {}

  if (cachedCountry) {
    var cachedCurrency = COUNTRY_CURRENCY[cachedCountry];
    if (cachedCurrency) loadRateAndRender(cachedCurrency);
    return;
  }

  fetchCountry()
    .then(function (countryCode) {
      try {
        sessionStorage.setItem('wtp_country', countryCode);
      } catch (e) {}
      var currency = COUNTRY_CURRENCY[countryCode];
      if (currency) {
        loadRateAndRender(currency);
      } else if (window.console) {
        console.info('[price-estimate] country ' + countryCode + ' has no configured currency; estimate hidden.');
      }
    })
    .catch(function (err) {
      if (window.console) console.warn('[price-estimate] geolocation lookup failed:', err);
    });
}

document.addEventListener('DOMContentLoaded', function () {
  // Transparent header -> solid header once scrolled past the video hero
  var transparentHeader = document.querySelector('.site-header-wrap.transparent-header');
  if (transparentHeader) {
    var toggleHeader = function () {
      if (window.scrollY > 60) {
        transparentHeader.classList.add('is-scrolled');
      } else {
        transparentHeader.classList.remove('is-scrolled');
      }
    };
    toggleHeader();
    window.addEventListener('scroll', toggleHeader, { passive: true });
  }

  // Mobile navigation drawer
  var menuToggle = document.getElementById('menuToggle');
  var drawer = document.getElementById('MobileDrawer');
  var drawerClose = document.getElementById('drawerClose');
  var drawerOverlay = document.getElementById('drawerOverlay');
  var pageWrapper = document.getElementById('PageWrapper');

  if (menuToggle && drawer && drawerOverlay) {
    var lastFocusedEl = null;

    function getFocusable() {
      return Array.prototype.slice.call(
        drawer.querySelectorAll('a[href], button:not([disabled])')
      );
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        closeDrawer();
      } else {
        trapFocus(e);
      }
    }

    function openDrawer() {
      lastFocusedEl = document.activeElement;

      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      drawerOverlay.classList.add('is-open');
      drawerOverlay.hidden = false;
      menuToggle.setAttribute('aria-expanded', 'true');

      document.documentElement.classList.add('menu-open');
      document.body.classList.add('menu-open');

      if (pageWrapper) {
        if ('inert' in HTMLElement.prototype) {
          pageWrapper.inert = true;
        } else {
          pageWrapper.setAttribute('aria-hidden', 'true');
        }
      }

      document.addEventListener('keydown', onKeydown);

      // Move focus into the drawer once the slide-in has started
      window.requestAnimationFrame(function () {
        drawerClose.focus();
      });
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOverlay.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');

      document.documentElement.classList.remove('menu-open');
      document.body.classList.remove('menu-open');

      if (pageWrapper) {
        if ('inert' in HTMLElement.prototype) {
          pageWrapper.inert = false;
        } else {
          pageWrapper.removeAttribute('aria-hidden');
        }
      }

      document.removeEventListener('keydown', onKeydown);

      var hideOverlay = function () {
        drawerOverlay.hidden = true;
      };
      drawerOverlay.addEventListener('transitionend', hideOverlay, { once: true });

      if (lastFocusedEl) {
        lastFocusedEl.focus();
      } else {
        menuToggle.focus();
      }
    }

    menuToggle.addEventListener('click', openDrawer);
    drawerClose.addEventListener('click', closeDrawer);
    drawerOverlay.addEventListener('click', closeDrawer);

    // Closing via a nav link: let the click navigate normally, just tidy state
    drawer.querySelectorAll('.drawer-nav a').forEach(function (link) {
      link.addEventListener('click', function () {
        document.documentElement.classList.remove('menu-open');
        document.body.classList.remove('menu-open');
      });
    });
  }

  // Hero carousel arrows
  document.querySelectorAll('[data-carousel-prev], [data-carousel-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('section').querySelector('.hero-carousel');
      if (!row) return;
      var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
      row.scrollBy({ left: dir * 320, behavior: 'smooth' });
    });
  });

  // Product page main gallery thumbnail swap
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('ProductMainImage');
      if (main && thumb.dataset.full) {
        main.src = thumb.dataset.full;
      }
      document.querySelectorAll('.product-thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  // New product-page functionality
  document.querySelectorAll('[data-carousel]').forEach(function (section) {
    if (!section.hasAttribute('data-recommendations')) {
      initCarousel(section);
    }
  });
  initRecommendations();
  initAccordions();
  initProductForm();
  initAjaxAddToCart();
  initQuantityStepper();
  initReviewReadMore();
  initPriceEstimate();
});

// The theme editor replaces a section's HTML via AJAX whenever a setting or
// block is changed (e.g. adding a review image), without a full page reload.
// The freshly-inserted markup has no event listeners yet, so re-run our
// initializers scoped to just that section whenever this happens.
document.addEventListener('shopify:section:load', function (event) {
  var root = event.target;
  if (!root || !root.querySelectorAll) return;

  root.querySelectorAll('[data-carousel]').forEach(function (section) {
    if (!section.hasAttribute('data-recommendations')) {
      initCarousel(section);
    } else {
      section.dataset.carouselInit = 'false';
      initRecommendations();
    }
  });

  if (root.querySelector('[data-accordion-list]')) {
    initAccordions();
  }
  if (root.querySelector('#ProductForm')) {
    initProductForm();
    initAjaxAddToCart();
    initPriceEstimate();
  }
  if (root.querySelector('.quantity-stepper')) {
    initQuantityStepper();
  }
  if (root.querySelector('[data-review-text]')) {
    initReviewReadMore();
  }
});
